module.exports = __webpack_public_path__ + "static/media/success.94aeb3d1.svg";